<form (submit)="onSearch()" class="searchFiltersForm">
    <div *ngFor="let searchParamsOnRow of searchParams.searchParamsGroupedByRow" class="searchFiltersRowContainer">
        <!-- ====================================================================== -->
        <!-- ADDED: colspan support for double surname feature                      -->
        <!-- When colspan > 1, the field spans multiple columns                     -->
        <!-- Used when Name field should span full width in double surname mode     -->
        <!-- ====================================================================== -->
        <div
            *ngFor="let searchParam of searchParamsOnRow; count as controlsNumber"
            [class.se-flex-1]="!!searchParam.layout?.stretch"
            [class.se-colspan-2]="searchParam.layout?.colspan === 2"
            class="searchFilterContainer"
        >
            <div
                [class.se-flex-1]="!!searchParam.layout?.stretch"
                [class.se-search-filter-max-width]="controlsNumber > 1 && !searchParam.layout?.colspan"
                [ngSwitch]="searchParam.property.type"
                class="se-flex search-filter-class"
                disabled="true"
            >
                <!-- Input - String -->
                <mat-form-field
                    *ngSwitchCase="searchParamType.string"
                    appearance="outline"
                    class="se-flex-1-1-auto se-form-field"
                >
                    <mat-label>{{
                            labelTranslationKeyToString(searchParam.labelTranslationKey) | translate
                        }}
                    </mat-label>
                    <input
                        (change)="onFilterChange(searchParam.property.name)"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        [autofocus]="!!searchParam.layout?.autofocus"
                        [disabled]="!!searchParam.layout?.disabled"
                        [name]="searchParam.property.name"
                        [placeholder]="labelTranslationKeyToString(searchParam.labelTranslationKey) | translate"
                        autocomplete="off"
                        class="se-trim se-form-field-input"
                        matInput
                        se-autofocus
                    />
                </mat-form-field>

                <!-- Combo -->
                <mat-form-field
                    *ngSwitchCase="searchParamType.select"
                    appearance="outline"
                    class="se-flex-1-1-auto se-form-field"
                >
                    <mat-label *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading"
                    >{{ labelTranslationKeyToString(searchParam.labelTranslationKey) | translate }}
                    </mat-label>
                    <mat-label *ngIf="searchParam.property.itemsSourceInfo?.dataLoading">
                        <div class="mat-select-waiting-spinner-container">
                            <mat-spinner class="spinner" diameter="16"></mat-spinner>
                            <span style="margin-left: 5px">{{ "Loading" | translate }}</span>
                        </div>
                    </mat-label>
                    <mat-select
                        (selectionChange)="onFilterChange(searchParam.property.name)"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        [autofocus]="!!searchParam.layout?.autofocus"
                        [disabled]="!!searchParam.layout?.disabled"
                        [name]="searchParam.property.name"
                        [placeholder]="labelTranslationKeyToString(searchParam.labelTranslationKey) | translate"
                        [typeaheadDebounceInterval]="500"
                        se-autofocus
                    >
                        <ng-container *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading">
                            <mat-option
                                *ngFor="let item of getDataForSelect(searchParam.property.name)"
                                [title]="searchParam.property.itemsSourceInfo?.enableTooltip?getDisplayProperty(item, searchParam):''"
                                [value]="item.id ?? item.guid"

                            >
                                {{ getDisplayProperty(item, searchParam) }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <button
                        (click)="resetComboSelectedValue(searchParam.property.name, $event)"
                        *ngIf="!searchParam.property.itemsSourceInfo?.disableResetButton"
                        class="se-button-no-ripple"
                        mat-icon-button
                        matSuffix
                        tabIndex="-1"
                        type="button"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <!-- Combo Multiselect -->
                <mat-form-field
                    *ngSwitchCase="searchParamType.multiSelect"
                    appearance="outline"
                    class="se-flex-1-1-auto se-form-field"
                >
                    <mat-label *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading"
                    >{{ labelTranslationKeyToString(searchParam.labelTranslationKey) | translate }}
                    </mat-label>
                    <mat-label *ngIf="searchParam.property.itemsSourceInfo?.dataLoading">
                        <div class="mat-select-waiting-spinner-container">
                            <mat-spinner class="spinner" diameter="16"></mat-spinner>
                            <span style="margin-left: 5px">{{ "Loading" | translate }}</span>
                        </div>
                    </mat-label>
                    <mat-select
                        (selectionChange)="onFilterChange(searchParam.property.name)"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        [autofocus]="!!searchParam.layout?.autofocus"
                        [disabled]="!!searchParam.layout?.disabled"
                        [name]="searchParam.property.name"
                        [placeholder]="labelTranslationKeyToString(searchParam.labelTranslationKey) | translate"
                        [typeaheadDebounceInterval]="500"
                        multiple
                        se-autofocus
                    >
                        <ng-container *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading">
                            <mat-option
                                *ngFor="let item of searchParam.property.itemsSourceInfo?.data ?? []"
                                [title]="searchParam.property.itemsSourceInfo?.enableTooltip?getDisplayProperty(item, searchParam):''"
                                [value]="item.id ?? item.guid"
                            >
                                {{ getDisplayProperty(item, searchParam) }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <button
                        (click)="resetComboSelectedValue(searchParam.property.name, $event)"
                        class="se-button-no-ripple"
                        mat-icon-button
                        matSuffix
                        tabIndex="-1"
                        type="button"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <!-- FilterCombo -->
                <mat-form-field
                    *ngSwitchCase="searchParamType.filterSelect"
                    appearance="outline"
                    class="se-flex-1-1-auto se-form-field"
                >
                    <mat-label *ngIf="searchParam.property.itemsSourceInfo?.dataLoading">
                        <div class="mat-select-waiting-spinner-container">
                            <mat-spinner class="spinner" diameter="16"></mat-spinner>
                            <span style="margin-left: 5px">{{ "Loading" | translate }}</span>
                        </div>
                    </mat-label>
                    <mat-label *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading"
                    >{{ labelTranslationKeyToString(searchParam.labelTranslationKey) | translate }}
                    </mat-label>
                    <mat-select
                        (selectionChange)="onFilterChange(searchParam.property.name)"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        [autofocus]="!!searchParam.layout?.autofocus"
                        [disabled]="!!searchParam.layout?.disabled"
                        [name]="searchParam.property.name"
                        [placeholder]="labelTranslationKeyToString(searchParam.labelTranslationKey) | translate"
                        [typeaheadDebounceInterval]="500"
                        se-autofocus
                    >
                        <mat-option>
                            <ngx-mat-select-search
                                (ngModelChange)="onSelectFiltering(searchParam.property.name, $event)"
                                [name]="searchParam.property.name + '__filter'"
                                [noEntriesFoundLabel]="'NoResults' | translate"
                                [placeholderLabel]="'Search' | translate"
                                ngModel
                            >
                            </ngx-mat-select-search>
                        </mat-option>

                        <ng-container *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading">
                            <mat-option
                                *ngFor="let item of getDataForSelect(searchParam.property.name)"
                                [title]="searchParam.property.itemsSourceInfo?.enableTooltip?getDisplayProperty(item, searchParam):''"
                                [value]="item.id ?? item.guid"
                            >
                                {{ getDisplayProperty(item, searchParam) }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <button
                        (click)="resetComboSelectedValue(searchParam.property.name, $event)"
                        class="se-button-no-ripple"
                        mat-icon-button
                        matSuffix
                        tabIndex="-1"
                        type="button"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <!-- Filter Combo Multiselect -->
                <mat-form-field
                    *ngSwitchCase="searchParamType.filterMultiSelect"
                    appearance="outline"
                    class="se-flex-1-1-auto se-form-field"
                >
                    <mat-label *ngIf="searchParam.property.itemsSourceInfo?.dataLoading">
                        <div class="mat-select-waiting-spinner-container">
                            <mat-spinner class="spinner" diameter="16"></mat-spinner>
                            <span style="margin-left: 5px">{{ "Loading" | translate }}</span>
                        </div>
                    </mat-label>
                    <mat-label *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading"
                    >{{ labelTranslationKeyToString(searchParam.labelTranslationKey) | translate }}
                    </mat-label>
                    <mat-select
                        (selectionChange)="onFilterChange(searchParam.property.name)"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        [autofocus]="!!searchParam.layout?.autofocus"
                        [disabled]="!!searchParam.layout?.disabled"
                        [name]="searchParam.property.name"
                        [placeholder]="labelTranslationKeyToString(searchParam.labelTranslationKey) | translate"
                        [typeaheadDebounceInterval]="500"
                        multiple
                        se-autofocus
                    >
                        <mat-option>
                            <ngx-mat-select-search
                                (ngModelChange)="onSelectFiltering(searchParam.property.name, $event)"
                                [name]="searchParam.property.name + '__filter'"
                                [noEntriesFoundLabel]="'NoResults' | translate"
                                [placeholderLabel]="'Search' | translate"
                                ngModel
                            >
                            </ngx-mat-select-search>
                        </mat-option>

                        <ng-container *ngIf="!searchParam.property.itemsSourceInfo?.dataLoading">
                            <mat-option
                                *ngFor="let item of getDataForSelect(searchParam.property.name)"
                                [title]="searchParam.property.itemsSourceInfo?.enableTooltip?getDisplayProperty(item, searchParam):''"
                                [value]="item.id ?? item.guid"

                            >
                                {{ getDisplayProperty(item, searchParam) }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <button
                        (click)="resetComboSelectedValue(searchParam.property.name, $event)"
                        class="se-button-no-ripple"
                        mat-icon-button
                        matSuffix
                        tabIndex="-1"
                        type="button"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <!--  fromTo -->
                <se-from-to
                    (fromToDatesChange)="onFilterChange(searchParam.property.name)"
                    (isOnErrorChange)="onFromToErrorChange($event)"
                    (searchRequired)="onSearch()"
                    *ngSwitchCase="searchParamType.fromTo"
                    [(fromToModel)]="searchParams.params[searchParam.property.name]"
                    [autofocus]="!!searchParam.layout?.autofocus"
                    [disabled]="!!searchParam.layout?.disabled"
                    [id]="searchParam.property.name"
                    [name]="searchParam.property.name"
                    [placeholder]="labelTranslationKeyToFromToLabel(searchParam.labelTranslationKey)"
                    class="se-from-to-component"
                >
                </se-from-to>

                <!--  date -->
                <mat-form-field
                    *ngSwitchCase="searchParamType.date"
                    appearance="outline"
                    class="se-flex-1-1-auto se-form-field"
                >
                    <mat-label>{{
                            labelTranslationKeyToString(searchParam.labelTranslationKey) | translate
                        }}
                    </mat-label>
                    <input
                        (dateChange)="onFilterChange(searchParam.property.name)"
                        (keydown.enter)="onEnterKeyDown($event)"
                        (keydown.space)="$event.preventDefault()"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        [autofocus]="!!searchParam.layout?.autofocus"
                        [disabled]="!!searchParam.layout?.disabled"
                        [id]="searchParam.property.name"
                        [matDatepicker]="searchDate"
                        [name]="searchParam.property.name"
                        [placeholder]="labelTranslationKeyToString(searchParam.labelTranslationKey) | translate"
                        class="se-form-field-input"
                        matInput
                        se-autofocus
                    />
                    <mat-datepicker-toggle
                        [for]="searchDate"
                        class="se-mat-datepicker-toggle se-button-no-ripple"
                        matSuffix
                    ></mat-datepicker-toggle>
                    <mat-datepicker #searchDate type="date"></mat-datepicker>
                </mat-form-field>

                <!-- Boolean - Check -->
                <div
                    *ngSwitchCase="searchParamType.boolean"
                    class="se-flex-1-1-auto"
                    style="display: flex; flex-direction: column"
                >
                    <div class="se-flex-1"></div>
                    <mat-checkbox
                        (change)="onFilterChange(searchParam.property.name)"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        [disabled]="!!searchParam.layout?.disabled"
                        [id]="searchParam.property.name"
                        [name]="searchParam.property.name"
                        labelPosition="after"
                    >
                        {{ labelTranslationKeyToString(searchParam.labelTranslationKey) | translate }}
                    </mat-checkbox>
                    <div style="flex: 1"></div>
                </div>

                <!-- Number - check -->
                <mat-form-field *ngSwitchCase="searchParamType.number" class="se-flex-1-1-auto se-form-field">
                    <mat-label>{{
                            labelTranslationKeyToString(searchParam.labelTranslationKey) | translate
                        }}
                    </mat-label>
                    <input
                        [name]="searchParam.property.name"
                        autocomplete="off"
                        class="se-form-field-input"
                        matInput
                        type="number"
                        [id]="searchParam.property.name"
                        [placeholder]="labelTranslationKeyToString(searchParam.labelTranslationKey) | translate"
                        [(ngModel)]="searchParams.params[searchParam.property.name]"
                        se-autofocus
                        [autofocus]="!!searchParam.layout?.autofocus"
                        [disabled]="!!searchParam.layout?.disabled"
                        (change)="onFilterChange(searchParam.property.name)"
                    />
                </mat-form-field>
            </div>
        </div>
    </div>

    <!-- submit -->
    <div class="se-flex-0-0-auto">
        <button hidden="hidden" type="submit"></button>
    </div>
</form>
